/**
 * Enum representing the types of adjustments that can be applied to an order.
 */
export enum AdjustmentType {
  Tax = 'Tax',
  Shipping = 'Shipping',
  Discount = 'Discount',
  Fee = 'Fee',
  Other = 'Other',
}
